import * as z from "zod";
import { gql } from "graphql-request";

import { SysSchema, SysFragment } from "../sys";
import { ImageSchema, ImageFragment } from "../image";
import { UnifiedButtonSchema, UnifiedButtonFragment } from "../unifiedButton";

export const FullscreenEntryCarouselSchema = z.object({
  sys: SysSchema,
  __typename: z.literal("FullscreenEntryCarousel"),
  expirationDate: z.string().nullable(),
  readMoreButton: UnifiedButtonSchema.nullish(),

  body: z
    .object({
      json: z.unknown(),
    })
    .nullish(),
  backgroundMedia: ImageSchema.nullable(),
  backgroundMediaEn: ImageSchema.nullable(),
});

export type FullscreenEntryCarousel = z.infer<
  typeof FullscreenEntryCarouselSchema
>;

export const FullscreenEntryCarouselFragment = gql`
  fragment FullscreenEntryCarouselFragment on FullscreenEntryCarousel {
    __typename
    sys {
      ...SysFragment
    }

    expirationDate

    readMoreButton {
      __typename
      ... on UnifiedButton {
        ...UnifiedButtonFragment
      }
    }

    body {
      json
    }

    backgroundMedia {
      ...ImageFragment
    }

    backgroundMediaEn: backgroundMedia(locale: "en") {
      ...ImageFragment
    }
  }

  ${SysFragment}
  ${UnifiedButtonFragment}
  ${ImageFragment}
`;
